import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Snackbar, Alert } from "@mui/material";
import axios from "axios";
import { format } from "date-fns";
import { base_url } from "../../../utils/AxiosConfig";
import dayjs from "dayjs";

let leaveStatusSchema = Yup.object().shape({
  CmpCode: Yup.string(),
  approvalNotes: Yup.string(),
  ticketStatus: Yup.string(),
  userName: Yup.string(),
});

const ApprovePopup = ({
  PopUpData,
  reloadApi,
  setReloadApi,
  setPopUpData,
  setIsModalOpen,
}) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = storedUserDataArray?.[0]?.cmpcode || null;

  const modalRef = useRef(null);
  const [Data, setData] = useState();
  const [LeaveStatusData, setLeaveStatusData] = useState();
  // const [FromDate, setFromDate] = useState();
  // const [ToDate, setToDate] = useState();
  const today = new Date().toISOString().split("T")[0];

  const [FromDate, setFromDate] = useState(today);
  const [ToDate, setToDate] = useState(today);
  const [LeaveHistoryData, setLeaveHistoryData] = useState();
  const [LeaveHistoryOtherData, setLeaveHistoryOtherData] = useState();
  const [Approved, setApproved] = useState(false);
  const [Rejected, setRejected] = useState(false);

  // Snackbar states
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success, error, warning, info
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      SerialNo: PopUpData?.serialcode,
      approvalNotes: "",
      ticketStatus: "Not Applicable",
      userName: "Hr Manager",
    },
    validationSchema: leaveStatusSchema,
    onSubmit: (values) => {
      setData(values);
    },
  });

  useEffect(() => {
    const formatted = format(
      new Date(PopUpData?.FromDate || null),
      "yyyy-MM-dd",
    );
    setFromDate(formatted);
  }, [PopUpData?.FromDate]);

  useEffect(() => {
    const formatted = format(new Date(PopUpData?.ToDate || null), "yyyy-MM-dd");
    setToDate(formatted);
  }, [PopUpData?.ToDate]);

  useEffect(() => {
    if (!PopUpData?.EmpId) return;

    const fetchData = async (type, setter) => {
      try {
        const res = await axios.get(
          `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/${type}/${PopUpData.EmpId}/${FromDate}/${ToDate}/-`,
        );
        if (res?.data) setter(res.data);
        if(type==='LEAVEHISTORYOTHER'){
          console.log('LEAVEHISTORYOTHER:',res.data)
        }
        console.log("")
      } catch {
        console.log("error");
      }
    };

    fetchData("LEAVEHISTORYOTHER", setLeaveHistoryOtherData);
    fetchData("LEAVESTATUS", setLeaveStatusData);
    fetchData("LEAVEHISTORY", setLeaveHistoryData);
  }, [PopUpData?.EmpId, FromDate, ToDate]);

  useEffect(() => {
    if (Approved && Data) {
      postStatusUpdate("APPROVED", "Approved Successfully", setApproved);
    }
  }, [Data, Approved]);

  useEffect(() => {
    if (Rejected && Data) {
      // if (Data.approvalNotes !== "nil") {
      if (Data.approvalNotes && Data.approvalNotes.trim() !== "") {
        postStatusUpdate("REJECTED", "Leave Rejected", setRejected);
      } else {
        showSnackbar("Notes are Required to Reject", "warning");
        setRejected(false);
      }
    }
  }, [Data, Rejected]);

  // const postStatusUpdate = async (status, successMsg, setState) => {

  const postStatusUpdate = async (status, successMsg, setState) => {
    // Check if notes are required for rejection
    if (!Data?.approvalNotes || Data.approvalNotes.trim() === "") {
      showSnackbar("Notes are required to Approve", "warning");
      setState(false);
      return;
    }

    try {
      const res = await axios.post(
        `${base_url}/api/PersonalInfoLeaveStatusUpdate/${companyCode}/${status}/${
          PopUpData?.serialcode || null
        }/${Data?.userName}/${Data?.ticketStatus}/${Data?.approvalNotes}`,
      );
      if (res?.data) {
        showSnackbar(successMsg, "success");
        setState(false);
        setPopUpData();
        setTimeout(() => {
          closeModal();
          setReloadApi(true);
        }, 1000); // 1.5 second delay
      }
    } catch {
      showSnackbar("Failed to update. Please try again.", "error");
      setState(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
        <div
          ref={modalRef}
          className="bg-white rounded-lg shadow-lg w-full max-w-6xl max-h-[90vh] overflow-y-auto"
        >
          {/* Header */}
          <div className="flex justify-between items-center border-b p-4">
            <h2 className="text-lg font-semibold">Status Update</h2>
            <button
              onClick={() => {
                reloadApi(true);
                closeModal();
              }}
              className="text-gray-500 hover:text-gray-800"
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <div className="p-4 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Current Leave Status */}
              <div>
                <p className="text-sm text-gray-500 mb-2">
                  Current Leave Status Of Employee
                </p>
                <div className="overflow-auto max-h-64 border rounded-lg">
                  <table className="w-full text-sm text-left">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="p-2">Si No</th>
                        <th className="p-2">Leave Category</th>
                        <th className="p-2">Alloted</th>
                        <th className="p-2">Consumed</th>
                        <th className="p-2">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {LeaveStatusData?.map((d, i) => (
                        <tr
                          key={i}
                          className="border-b hover:bg-gray-50 transition"
                        >
                          <td className="p-2">{i + 1}</td>
                          <td className="p-2">{d?.LEAVECATEGORY}</td>
                          <td className="p-2">{d?.ALLOTED}</td>
                          <td className="p-2">{d?.CONSUMED}</td>
                          <td className="p-2">{d?.Balance}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Form */}
              <div>
                <form onSubmit={formik.handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">
                      Flight Ticket
                    </label>
                    <select
                      name="ticketStatus"
                      onBlur={formik.handleBlur("ticketStatus")}
                      value={formik.values.ticketStatus}
                      onChange={formik.handleChange("ticketStatus")}
                      className="mt-1 block w-full border border-gray-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-500"
                    >
                      <option>Not Applicable</option>
                      <option value="One Way">One Way</option>
                      <option value="Two Way">Two Way</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600">
                      Notes
                    </label>
                    <textarea
                      name="approvalNotes"
                      onBlur={formik.handleBlur("approvalNotes")}
                      value={formik.values.approvalNotes}
                      onChange={formik.handleChange("approvalNotes")}
                      placeholder="Your notes here..."
                      className="mt-1 block w-full border border-gray-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div className="flex justify-end gap-3">
                    <button
                      type="submit"
                      onClick={() => setApproved(true)}
                      className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
                    >
                      Approve
                    </button>
                    <button
                      type="submit"
                      onClick={() => setRejected(true)}
                      className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
                    >
                      Reject
                    </button>
                  </div>
                </form>

                {/* Leave History */}
                <div className="mt-6">
                  <p className="text-sm text-gray-500 mb-2">
                    Leave History of Employee
                  </p>
                  <div className="overflow-auto max-h-64 border rounded-lg">
                    <table className="w-full text-sm text-left">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="p-2">Si No</th>
                          <th className="p-2">Leave Type</th>
                          <th className="p-2">From Dt</th>
                          <th className="p-2">To Dt</th>
                          <th className="p-2">Leaves</th>
                          <th className="p-2">Rejoin</th>
                          <th className="p-2">Status</th>
                          <th className="p-2">Ticket</th>
                        </tr>
                      </thead>
                      <tbody>
                        {LeaveHistoryData?.map((d, i) => (
                          <tr
                            key={i}
                            className="border-b hover:bg-gray-50 transition"
                          >
                            <td className="p-2">{i + 1}</td>
                            <td className="p-2">{d?.Leave_Type}</td>
                            <td className="p-2">{d["FROM-DT"]}</td>
                            <td className="p-2">{d["TO-DATE"]}</td>
                            <td className="p-2">{d?.LEAVES}</td>
                            <td className="p-2">{d?.Re_joinOn}</td>
                            <td className="p-2">{d?.Status}</td>
                            <td className="p-2">{d?.Ticket}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Other Employees Table */}
            <div>
              <p className="text-sm text-gray-500 mb-2">
                Other Employees Approved Leaves in the Selected Period
              </p>
              <div className="overflow-auto max-h-64 border rounded-lg">
                <table className="w-full text-sm text-left">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2">Si No</th>
                      <th className="p-2">Emp Id</th>
                      <th className="p-2">Name</th>
                      <th className="p-2">Job Title</th>
                      <th className="p-2">Leave Name</th>
                      <th className="p-2">Application Date</th>
                      <th className="p-2">Leave From</th>
                      <th className="p-2">Leave To</th>
                    </tr>
                  </thead>
                  <tbody>
                    {LeaveHistoryOtherData?.map((d, i) => (
                      <tr
                        key={i}
                        className="border-b hover:bg-gray-50 transition"
                      >
                        <td className="p-2">{i + 1}</td>
                        <td className="p-2">{d?.EmpId}</td>
                        <td className="p-2">{d?.Name}</td>
                        <td className="p-2">{d?.JobTitle}</td>
                        <td className="p-2">{d?.Leave_Name}</td>
                        <td className="p-2">{dayjs(d?.ApplicationDate).format("YYYY-MM-DD")}</td>
                        <td className="p-2">{dayjs(d?.Leave_From).format("YYYY-MM-DD")}</td>
                        <td className="p-2">{dayjs(d?.Leave_To).format("YYYY-MM-DD")}</td>

                                                        
       
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MUI Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ApprovePopup;
